/**
 * Hand a table to the person as a file. UTF-8 with a BOM so Excel on Windows
 * opens Cyrillic correctly; semicolons because a Russian-locale Excel splits
 * on those, not commas.
 */
export function downloadCsv(filename: string, header: string[], rows: Array<Array<string | number | boolean | null | undefined>>): void {
  const cell = (v: string | number | boolean | null | undefined) => {
    if (v === null || v === undefined) return '';
    const s = String(v);
    return /[;"\n\r]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
  };
  const text = [header, ...rows].map((r) => r.map(cell).join(';')).join('\r\n');
  const blob = new Blob([`\uFEFF${text}`], { type: 'text/csv;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
